import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer } from '@splashthat/sui';

import FormTemplateLibraryCollection from './FormTemplateLibraryCollection';
import {
    getMode,
    getIsAdditional,
    getReservedCategoryTemplates,
    getAdditionalReservedCategoryTemplates,
    getNonReservedCategoryTemplates,
} from '../../selectors/templateLibrary';
import { GROUP_LEVEL } from '../../constants/templateLibrary';

const baseClassName = 'FormTemplateLibraryStock';

const FormTemplateLibraryStock = ({
    reservedTemplates,
    nonReservedTemplates,
    onClickTemplate,
    alreadyAddedUniqueNames,
}) => (
    <SuiContainer className={baseClassName} variation="flex-vertical flex-inherit">
        <FormTemplateLibraryCollection
            templates={[...reservedTemplates, ...nonReservedTemplates]}
            onClickTemplate={onClickTemplate}
            alreadyAddedUniqueNames={alreadyAddedUniqueNames}
            qaId={baseClassName}
        />
    </SuiContainer>
);

FormTemplateLibraryStock.propTypes = {
    reservedTemplates: PropTypes.array.isRequired,
    nonReservedTemplates: PropTypes.array.isRequired,
    onClickTemplate: PropTypes.func.isRequired,
    alreadyAddedUniqueNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state) => {
    const mode = getMode(state);
    const isAdditional = getIsAdditional(state);
    const reservedTemplates =
        mode === GROUP_LEVEL
            ? isAdditional
                ? getAdditionalReservedCategoryTemplates(state)
                : []
            : getReservedCategoryTemplates(state);

    const nonReservedTemplates = getNonReservedCategoryTemplates(state);

    return {
        reservedTemplates,
        nonReservedTemplates,
    };
};

export default connect(mapStateToProps)(FormTemplateLibraryStock);
